import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { Languages } from '../models/enums.model';
import { SupplierBidSubscriptionDto } from '../models/supplier-bid-subsription.model';
import { GlobalServices } from 'src/app/shared/services/global.service';


@Injectable({
  providedIn: 'root'
})
export class SupplierBidSubsriptionService {

  constructor(private http:HttpServices,private global: GlobalServices) { }

  public AddSupplierBidSubscription(supplierBidSubscriptionDto:SupplierBidSubscriptionDto) {
    return this.http.post('SupplierBidSubscription/AddSupplierBidSubscription', supplierBidSubscriptionDto);
  }

  public GetAll() {
    return this.http.get('SupplierBidSubscription/GetAll');
  }
  public GetSupplierBidSubscriptionPaged(pageIndex:number,pageSize:number,dateFrom: string, dateTo: string) {
    return this.http.get('SupplierBidSubscription/GetSupplierBidSubscriptionPaged?pageIndex=' + pageIndex + '&pageSize=' + pageSize+'&creationDateFrom=' + dateFrom + '&creationDateTo=' + dateTo+'&language=Ar');
  }
}